// RGB color type

export type RGBColor = {
  r: number // red
  g: number // green
  b: number // blue
  a: number // alpha
}
